import { useSelector } from 'react-redux';
import React, { Fragment, useEffect, useState } from 'react';

import { Box, Grid } from '@mui/material';

import InventoryList from './components/InventoryList';
import { handleErrorAlert } from 'utils/handleErrorAlert';
import { useCompanyService } from 'store/services/company.service';
import EmailDetailsAccordion from './components/EmailDetailsAccordion';
import InventoryEmailFilters from './components/InventoryEmailFilters';
import { TablePagination, CircleLoading, SnackBarAlert, Typography } from 'shared';

const InventoryEmailsTab = () => {
    const companyData = useSelector((state) => state.company.data);
    const { getCompanyEmailsWithInventory } = useCompanyService();

    const [page, setPage] = useState(1);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState(null);
    const [alertData, setAlertData] = useState({
        message: '',
        open: false,
        severity: '',
    });

    const handleGetCompanyEmailsWithInventory = async (pageNumber, filters = {}) => {
        try {
            setLoading(true);
            const response = await getCompanyEmailsWithInventory({
                companyId: companyData?.id,
                page: pageNumber,
                ...filters,
            });

            setData(response);
        } catch (error) {
            handleErrorAlert(setAlertData);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = async (pageNumber) => {
        setPage(pageNumber);

        await handleGetCompanyEmailsWithInventory(pageNumber, filters);
    };

    const handleFiltersSubmit = async (values) => {
        try {
            setPage(1);
            setFilters(values);
            handleGetCompanyEmailsWithInventory(1, values);
        } catch (error) {
            handleErrorAlert(setAlertData);
        }
    };

    useEffect(() => {
        if (companyData) {
            handleGetCompanyEmailsWithInventory(page);
        }
    }, [companyData]);

    return (
        <Fragment>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <InventoryEmailFilters handleFiltersSubmit={handleFiltersSubmit} />
                </Grid>
                {!loading && companyData && data ? (
                    data?.results?.length > 0 ? (
                        <Box width="100%" paddingLeft="15px">
                            {data?.results?.map((email) => (
                                <Fragment key={email.id}>
                                    <Grid item xs={12}>
                                        <EmailDetailsAccordion email={email} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InventoryList
                                            data={email?.inventories}
                                            company_email_id={email.id}
                                            refreshData={() =>
                                                handleGetCompanyEmailsWithInventory(1)
                                            }
                                            setAlertData={setAlertData}
                                        />
                                    </Grid>
                                </Fragment>
                            ))}
                            <Grid item xs={12} p={'10px 0'}>
                                <TablePagination
                                    rowsPerPage={30}
                                    page={page}
                                    count={data.count}
                                    onChange={(e, pageNumber) => handlePageChange(pageNumber)}
                                />
                            </Grid>
                        </Box>
                    ) : (
                        <Grid
                            item
                            xs={12}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Typography text="No emails found" />
                        </Grid>
                    )
                ) : (
                    <CircleLoading />
                )}
            </Grid>
            <SnackBarAlert alertData={alertData} setAlertData={setAlertData} />
        </Fragment>
    );
};

export default InventoryEmailsTab;
